import React from 'react';
import { Space, Button } from 'antd';
import i18next from 'i18next';
import { ALPHABET } from 'configs/localData';
import { useHistory, useLocation } from 'react-router';
import { convertSearchUrl, getFilterFromUrl } from 'utils/tools';
import { omit } from 'lodash-es';
import { DEFAULT_CURRENT_PAGE } from 'configs/localData/constant';
import AlphabetBarStyles from './styles';

const AlphabetBar = () => {
  const { push } = useHistory();

  const { search } = useLocation();

  const { filter: query } = getFilterFromUrl(search);
  const selectedValue = query?.beginLetter || null;

  const onSelected = (value) => {
    const filterParams = {
      ...query,
      page: DEFAULT_CURRENT_PAGE,
      beginLetter: value,
    };
    if (value !== selectedValue) {
      push({
        search: `?${convertSearchUrl({
          ...omit(filterParams, ['page']),
        })}`,
      });
    }
  };

  return (
    <AlphabetBarStyles>
      <Space wrap>
        <Button
          type={selectedValue ? 'default' : 'primary'}
          onClick={() => onSelected(null)}
        >
          {i18next.t('common.all')}
        </Button>
        {ALPHABET.map((value) => (
          <Button
            key={value}
            type={value === selectedValue ? 'primary' : 'default'}
            onClick={() => onSelected(value)}
          >
            {value}
          </Button>
        ))}
      </Space>
    </AlphabetBarStyles>
  );
};

export default AlphabetBar;
